import { type ComponentType, lazy } from 'react'

function isChunkError(error: unknown): boolean {
  const msg = error instanceof Error ? error.message : ''
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('is not a valid JavaScript MIME type')
  )
}

// biome-ignore lint/suspicious/noExplicitAny: generic component props
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(() =>
    factory().catch((error) => {
      if (isChunkError(error)) {
        window.location.reload()
        return new Promise<{ default: T }>(() => {})
      }
      throw error
    }),
  )
}
